import axios from "./httpService";

export default {
  messagesSearchApi: ({ chatId, ...params }) =>
    axios.get(`/v3/chats/${chatId}/messages`, { params }),
  messageSendApi: (params, options) => axios.post("/v3/chats", params, options),
  messageReadApi: ({ chat_id }) => axios.put(`/v3/chats/${chat_id}/read`)
};
